
import { Component, inject, Input, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/services/common-service/common.service';

@Component({
    selector: 'app-print-layout',
    imports: [],
    templateUrl: './print-layout.component.html',
    styleUrl: './print-layout.component.css',
    standalone: true
})
export class PrintLayoutComponent {
  private commonService = inject(CommonService);
  printableData:string= "";
  order = {
    id: '12345',
    date: new Date().toLocaleDateString(),
    items: [
      { name: 'Product 1', quantity: 2, price: 150 },
      { name: 'Product 2', quantity: 1, price: 300 }
    ],
    total: 600
  };

  ngOnInit(){
    this.commonService.printableData$.subscribe((data: string) => {
      this.printableData = data;
    });
  }

  printBillPaper() {
    const printContents = document.getElementById('printable-bill')?.innerHTML;
    const originalContents = document.body.innerHTML;

    if (printContents) {
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // Reload to restore the original content
    }
  }
}
